import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Instagram } from "lucide-react";

export const InstagramCTA = () => {
  const [handle, setHandle] = useState("");

  useEffect(() => {
    api.get("/config/fees").then((r) => setHandle((r.data?.instagram || "").replace(/^@/, ""))).catch(() => {});
  }, []);

  if (!handle) return null;

  return (
    <section className="py-16">
      <div className="mx-auto max-w-5xl px-4 sm:px-6">
        <a
          href={`https://instagram.com/${handle}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="instagram-cta"
          className="group relative block overflow-hidden rounded-2xl bg-gradient-to-br from-[#833AB4] via-[#E1306C] to-[#F77737] p-8 sm:p-10 shadow-2xl shadow-pink-500/20 hover:shadow-pink-500/40 transition-all hover:-translate-y-0.5"
        >
          <div className="absolute -top-10 -right-10 opacity-20">
            <Instagram className="w-56 h-56 text-white" strokeWidth={1.2} />
          </div>
          <div className="relative flex flex-col sm:flex-row sm:items-center gap-6">
            <div className="w-16 h-16 rounded-2xl bg-white/15 backdrop-blur-md flex items-center justify-center shrink-0 border border-white/20">
              <Instagram className="w-8 h-8 text-white" />
            </div>
            <div className="flex-1">
              <div className="text-xs font-mono uppercase tracking-widest text-white/80 mb-2">Siga-nos no Instagram</div>
              <h3 className="text-2xl sm:text-3xl font-black text-white leading-tight">
                Veja nossos trabalhos<br className="hidden sm:block" /> em tempo real
              </h3>
              <p className="text-white/90 mt-2 text-sm">Dicas de climatização, antes e depois, bastidores do atendimento.</p>
            </div>
            <div className="shrink-0">
              <div className="inline-flex items-center gap-2 bg-white text-slate-900 px-6 py-3 rounded-full font-bold group-hover:scale-105 transition-transform">
                <span>@{handle}</span>
                <span className="text-sm font-mono">→</span>
              </div>
            </div>
          </div>
        </a>
      </div>
    </section>
  );
};
